import type { FaceShapeId } from '../types';

interface ShapeGlyphProps {
  shape: FaceShapeId;
  measured?: boolean;
  label?: string;
  className?: string;
}

const SHAPE_PATHS: Record<FaceShapeId, string> = {
  oval: 'M60 8C31 8 18 31 18 66c0 39 19 70 42 70s42-31 42-70C102 31 89 8 60 8Z',
  round: 'M60 15c-29 0-44 22-44 55 0 35 20 60 44 60s44-25 44-60c0-33-15-55-44-55Z',
  square: 'M60 10C31 10 17 29 17 59v34c0 27 18 43 43 43s43-16 43-43V59c0-30-14-49-43-49Z',
  oblong: 'M60 5C35 5 23 28 23 68c0 45 17 71 37 71s37-26 37-71C97 28 85 5 60 5Z',
  heart: 'M60 8C25 8 13 30 17 62c4 31 21 62 43 76 22-14 39-45 43-76 4-32-8-54-43-54Z',
  diamond: 'M60 6C42 6 28 25 18 59c-5 19 3 49 17 67 8 10 17 15 25 15s17-5 25-15c14-18 22-48 17-67C92 25 78 6 60 6Z',
  triangle: 'M60 9C39 9 27 29 24 58c-3 27-4 53 10 67 8 8 17 13 26 13s18-5 26-13c14-14 13-40 10-67C93 29 81 9 60 9Z',
};

export function ShapeGlyph({
  shape,
  measured = false,
  label,
  className = '',
}: ShapeGlyphProps): React.ReactElement {
  const accessibleLabel = label ?? `${shape} face shape outline`;

  return (
    <svg
      className={`shape-glyph ${className}`.trim()}
      viewBox="0 0 120 146"
      role="img"
      aria-label={accessibleLabel}
    >
      <path className="shape-glyph__outline" d={SHAPE_PATHS[shape]} />
      {measured ? (
        <g className="shape-glyph__measurements">
          <path d="M60 10v128" />
          <path d="M25 48h70" />
          <path d="M19 72h82" />
          <path d="M27 103h66" />
          <rect x="56" y="6" width="8" height="8" rx="1" />
          <rect x="56" y="134" width="8" height="8" rx="1" />
          <rect x="21" y="44" width="8" height="8" rx="1" />
          <rect x="91" y="44" width="8" height="8" rx="1" />
          <rect x="15" y="68" width="8" height="8" rx="1" />
          <rect x="97" y="68" width="8" height="8" rx="1" />
          <rect x="23" y="99" width="8" height="8" rx="1" />
          <rect x="89" y="99" width="8" height="8" rx="1" />
        </g>
      ) : null}
    </svg>
  );
}
